(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const oldOptionId = 'BwytxJHHBf5Tp4UJ__nPArvYDFjUxL';
  const isOldNote = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes('necesitas agregar una nota sobre tu pedido');
  function removeOldNote() {
    const sets = window.ap_front_settings?.config?.optionset;
    if (Array.isArray(sets)) {
      for (const set of sets) {
        if (Array.isArray(set.options)) set.options = set.options.filter((option) => option.option_id !== oldOptionId && !isOldNote(option.label_product));
      }
    }
    for (const field of document.querySelectorAll('textarea')) {
      if (field.closest('.sanam-order-note')) continue;
      const label = field.id ? Array.from(document.querySelectorAll('label')).find((item) => item.htmlFor === field.id) : null;
      if (!isOldNote(field.name) && !isOldNote(label?.textContent) && !isOldNote(field.parentElement?.textContent)) continue;
      field.disabled = true;
      field.removeAttribute('name');
      const parent = field.parentElement;
      if (parent && parent.textContent.length < 600 && parent.querySelectorAll('textarea,input,select,button,a').length === 1) {
        parent.remove();
      } else {
        if (label) label.remove();
        field.remove();
      }
    }
    for (const label of document.querySelectorAll('label,p,span,strong')) {
      if (label.closest('.sanam-order-note') || label.children.length > 1) continue;
      if (isOldNote(label.textContent) && label.textContent.length < 200) label.remove();
    }
  }
  removeOldNote();
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; removeOldNote(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', removeOldNote, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
